/**
 * Design Tokens: Spacing
 * Consistent spacing scale (based on 4px grid)
 */

export const spacing = {
  // Base unit
  unit: 4,

  // Named spacing
  xs: 4,    // 4px
  sm: 8,    // 8px
  md: 12,   // 12px
  lg: 16,   // 16px
  xl: 20,   // 20px
  '2xl': 24,
  '3xl': 32,
  '4xl': 40,

  // Component-specific
  table: {
    cellPadding: 7,
    cellPaddingLg: 10,
    headerHeight: 100,
  },

  card: {
    padding: 16,
    paddingLg: 24,
    borderRadius: 10,
  },

  modal: {
    padding: 32,
    borderRadius: 12,
  },
} as const;

export type Spacing = typeof spacing;

// Helper to convert to px string
export const px = (value: number): string => `${value}px`;
